<div class="dialog">
  <div class="text_heading-5">{{ 'components.successfulSaveDialog.labels.title' | translate }}</div>

  <div class="dialog__content">
    <div>{{ 'components.successfulSaveDialog.labels.contentRow1' | translate }}</div>

    <div>
      {{ 'components.successfulSaveDialog.labels.contentRow2' | translate }}
    </div>

    <div>
      {{ 'components.successfulSaveDialog.labels.contentRow3' | translate : { value: requestTitle } }}
    </div>
  </div>

  <div>
    <button tuiButton (click)="onClickExitButton()">{{ 'common.buttons.continue' | translate }}</button>
  </div>
</div>
